import React, { FC } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import "./Select.css";

/*
interface IArrayTypes {
  item: string | number | readonly string[] | undefined;
  index: number
}

interface ISelectProps {
  value: string;
  options: Array<IArrayTypes>;
  onChange: () => void;
}

*/

interface ISelectProps {
  value: string;
  options: Array<any>;
  onChange: () => void;
}

const SimpleSelect: FC<ISelectProps> = ({ value, onChange, options }) => {
  return (
    <div
      style={{
        border: "none",
      }}
    >
      <FormControl
        variant="outlined"
        style={{
          width: 280,
          height: 52,
          background: "#ffffff",
          border: "none",
          boxSizing: "border-box",
          boxShadow: "0px 0px 12px rgba(0, 0, 0, 0.15)",
          borderRadius: 15,
          outline: "none",
        }}
      >
        <InputLabel id="demo-simple-select-outlined-label"></InputLabel>
        <Select value={value} onChange={onChange} label="Scegli tempo">
          <MenuItem value="">
            <em>&mdash;</em>
          </MenuItem>
          {options
            ? options.map((item, index) => {
                return (
                  <MenuItem key={index} value={item}>
                    {item}
                  </MenuItem>
                );
              })
            : null}
        </Select>
      </FormControl>
    </div>
  );
};

export default SimpleSelect;
